<template>
	<div class="row command">
		<div class="col-sm-12 col-md-12">
            <b-nav fill tabs>
                <template v-for="(item, i) in items">
                    <b-nav-item
                        :key="i"
                        v-if="item.type != 'dropdown'"
                        :active="item.active"
                        :disabled="item.disabled"
                        :to="item.to"
                    >{{ $t(item.title) }}</b-nav-item>

                    <b-nav-item-dropdown
                        :key="i"
                        :class="item.active ? 'bnid active' : 'bnid'"
                        v-else
                        id="nav7_ddown"
                        :text="$t(item.title)"
                        left
                    >
                        <b-dropdown-item :disabled="item.disabled" :to="item.to">
                            <i class="fa fa-list"></i>
                            {{ $t('All Variables') }}
                        </b-dropdown-item>
                        <b-dropdown-item :disabled="item.disabled" :to="item.to + '/0'">
                            <i class="fa fa-plus"></i>
                            {{ $t('New Variable') }}
                        </b-dropdown-item>
                        <b-dropdown-item
                            v-for="v in $store.state.go_variables"
                            :to="item.to + '/' + v.var_id"
                            :key="v.var_id"
                        >
                            <i class="fa fa-edit"></i>
                            {{ v.var_name }}
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                </template>
            </b-nav>
			<b-card class="bt-parent border-top-0 m-0 rounded-0 mb-4 command-area">
                <div class="row">
                    <div class="col-sm-12 col-md-12">
                        <slot/>
                    </div>
                </div>
			</b-card>
		</div>
	</div>
</template>
<script>
import axios from 'axios'

export default {
	props: ['command_service_id', 'record_id', 'active'],
	data() {
		return {
			items: [],
		}
	},
	methods: {
		init(sId, cId, t) {
			this.$store.commit('set_go_services_id', sId)
			this.$store.commit('set_go_commands_id', cId)
			let items = [
				{title: 'about', disabled: false, active: false},
				{title: 'variables', disabled: true, active: false, type: 'dropdown'},
				{title: 'examples', disabled: true, active: false},
				{title: 'response', disabled: true, active: false},
				{title: 'advertises', disabled: true, active: false},
				// {title: 'result', disabled: true, active: false},
			]
			this.items = items.reduce((a, b) => {
				return a.concat({
					...b,
					active: b.title === t,
					disabled: !(parseInt(cId) > 0),
					to: '/services/' + sId + '/commands/' + cId + '/' + b.title,
				})
			}, [])
		},
	},
	watch: {
		command_service_id(newVal) {
			this.init(newVal, this.record_id, this.active)
		},
		record_id(newVal) {
			this.init(this.command_service_id, newVal, this.active)
		},
	},
	created() {
		this.$store.watch(this.$store.getters.get_go_commands_id, (commandId) => {
			if (commandId) {
				axios
					.post('/command_var/get_all/' + commandId)
					.then((response) => {
						if (response.data.status === 1) {
							this.$store.commit('set_go_variables', response.data.data)
						}
					})
					.catch((e) => {
						this.$store.commit('set_go_variables', []) // clear temp variables
					})
			} else {
				this.$store.commit('set_go_variables', []) // clear temp variables
			}
		})
		this.init(this.command_service_id, this.record_id, this.active)
    },
}
</script>
